import React, { FC } from 'react'
import styles from 'styles/components/card.module.scss'
import { Spacer } from 'components/Utility'
import { FlexRow } from 'components/Flex'

type Props = {
  basketNumber: string
  orderTimes: number
  tel: string
  username: string
}

const PrintOrderHeader: FC<Props> = (props) => {
  const { basketNumber, orderTimes, tel, username } = props

  return (
    <div>
      <FlexRow justifyContent={'between'}>
        <FlexRow justifyContent={'start'}>
          <span className={styles.printOrder__header__label}>受け渡し番号 ： </span>
          <Spacer size={4} />
          <h2 className={styles.printOrder__header__number}>{basketNumber}</h2>
        </FlexRow>
        <Spacer size={8} />
        <FlexRow justifyContent={'end'}>
          <span className={styles.printOrder__header__username}>
            {username}様({orderTimes}回目)
          </span>
          <Spacer size={24} />
          <span className={styles.printOrder__header__tel}>{tel}</span>
        </FlexRow>
      </FlexRow>
    </div>
  )
}

export default PrintOrderHeader
